import buyPacks from 'assets/img/homepage/how-to-play_buypacks.svg'
import identity from 'assets/img/homepage/how-to-play_identity.svg'
import prediction from 'assets/img/homepage/how-to-play_prediction.svg'
import prize from 'assets/img/homepage/how-to-play_prize.svg'
import event from 'assets/img/homepage/how-to-play_event.svg'
import trade from 'assets/img/homepage/how-to-play_trade.svg'
import bottomBg from 'assets/img/homepage/how-to-play-bg.svg'

const HomepageHowToPlay = ({activateLogin}) => {

  const listData = [
    {
      icon: buyPacks,
      title: 'Buy Card Packs',
      descr: `Purchase Identity Card packs and Prediction Card packs to collect the component cards needed to craft identity cards and predictions.`
    },
    {
      icon: identity,
      title: 'Create an Identity',
      descr: `Identity cards are the heart of TwoTwentyK. They are the 'who' in your prediction. Rip Identity Card packs to find the day, month, year and category cards you need to craft the identities of people you want to make predictions about. Identity cards are reusable and their stats are updated after every prediction.`
    },
    {
      icon: prediction,
      title: 'Make a Prediction',
      descr: 'Prediction packs contain the event and trigger cards needed to make capitalize predictions. Combine an Identity card with trigger cards like “wins” or “loses,” and event cards such as ‘Week 1 NFL Game’ or ‘Academy Award for Best Actor’ to make a prediction about what the outcome of those real-world events will be.'
    },
    {
      icon: prize,
      title: 'Prize Cards',
      descr: 'Prize cards of various denominations are found randomly in both Identity and Prediction card packs. Select a prize card from your inventory to include in your Prediction. A Prize card becomes redeemable when your prediction resolves true. Want to try and earn a bigger prize? Combine several smaller prize cards into a single card of greater value.'
    },
    {
      icon: event,
      title: 'Enjoy the Event',
      descr: 'Hold your prediction until the event occurs. If your prediction resolves true, your prize card becomes redeemable for cash, your identity  card is returned and the other cards are burned. If it resolves false, your Identity is returned but all the other cards are burned.'
    },
    {
      icon: trade,
      title: 'Buy and Sell Cards',
      descr: 'Can’t find a that year card you need? Have multiple identities of the same person? Use the in-game marketplace to buy hard to find cards, sell excess inventory, or quickly assemble the cards you need for that last minute prediction idea.'
    },
  ]

  return (
    <section className='homepage-how-play' id='how-to-play'>
      <img src={bottomBg} className='homepage-how-play__bg-bottom' alt="" />
      <h2 className='homepage__second-title'>How to play</h2>
      <p className='homepage__description'>
        Buy and collect trading cards, combine them to create identities of famous people,
        then use them to make predictions about the outcome of real life events.
      </p>
      <ul className="homepage-how-play__list">
        {
          listData.map((item, index) => (
            <li className="homepage-how-play__list-item" key={index}>
              <img src={item.icon} loading='lazy' alt="" />
              <b>{item.title}</b>
              <p>{item.descr}</p>
            </li>
          ))
        }
      </ul>
      <button className='homepage__play-now' onClick={activateLogin}>Play now</button>
    </section>
  )
}

export default HomepageHowToPlay
